import React from "react";

const TermsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="mb-6">Terms of Service</h1>

      <div className="prose prose-lg max-w-none space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            1. Acceptance of Terms
          </h2>
          <p className="text-gray-600">
            By accessing and using seriv.io, you accept and agree to be bound by
            these Terms of Service. If you do not agree to these terms, please
            do not use the service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            2. Description of Service
          </h2>
          <p className="text-gray-600">
            seriv.io is a personal fitness tracking application that allows you
            to log workouts, exercises, sets, and repetitions. This is an
            application provided free of charge.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            3. Use at Your Own Risk
          </h2>
          <p className="text-gray-600 mb-2">
            THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. We
            make no guarantees about:
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
            <li>Accuracy of workout data or calculations</li>
            <li>Availability or uptime of the service</li>
            <li>Data preservation or backup</li>
            <li>Fitness advice or health recommendations</li>
          </ul>
          <p className="text-gray-600 mt-2">
            Always consult with a healthcare professional before starting any
            fitness program.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            4. Account Responsibilities
          </h2>
          <p className="text-gray-600 mb-2">You are responsible for:</p>
          <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
            <li>Maintaining the security of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us of any unauthorized access</li>
            <li>The accuracy of information you provide</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            5. Prohibited Uses
          </h2>
          <p className="text-gray-600 mb-2">You agree NOT to:</p>
          <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
            <li>Abuse, harass, or harm other users</li>
            <li>
              Attempt to gain unauthorized access to our systems or other users'
              accounts
            </li>
            <li>Use automated tools to scrape or download data</li>
            <li>Reverse engineer or decompile the application</li>
            <li>
              Overload or disrupt the service (including attempts to bypass rate
              limits)
            </li>
            <li>Upload malicious code, viruses, or harmful content</li>
            <li>Violate any applicable laws or regulations</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            6. Rate Limiting
          </h2>
          <p className="text-gray-600">
            To protect service availability, we enforce rate limits of 800
            requests per day and 200 requests per hour per IP address. Exceeding
            these limits may result in temporary or permanent account
            suspension.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            7. Limitation of Liability
          </h2>
          <p className="text-gray-600">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR
            ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
            DAMAGES, OR ANY LOSS OF PROFITS, DATA, USE, OR GOODWILL, ARISING
            FROM YOUR USE OF THE SERVICE, EVEN IF WE HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            8. Termination
          </h2>
          <p className="text-gray-600">
            We reserve the right to suspend or terminate your account at any
            time, with or without notice, for any reason, including violation of
            these terms, abuse of the service, or at our sole discretion. You
            may also terminate your account at any time by contacting us.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            9. Data Loss
          </h2>
          <p className="text-gray-600">
            While we take reasonable measures to protect your data, we cannot
            guarantee against data loss. You are responsible for maintaining
            your own backups if needed. We are not liable for any data loss or
            corruption.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            10. Changes to Terms
          </h2>
          <p className="text-gray-600">
            We may modify these Terms of Service at any time. Continued use of
            the service after changes constitutes acceptance of the modified
            terms. We will make reasonable efforts to notify users of
            significant changes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            11. Governing Law
          </h2>
          <p className="text-gray-600">
            These terms shall be governed by and construed in accordance with
            the laws of Sweden, without regard to its conflict of law
            provisions.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            12. Contact
          </h2>
          <p className="text-gray-600">
            For questions about these Terms of Service, please{" "}
            <a href="/contact" className="text-blue-600 underline">
              contact us
            </a>{" "}
            through the contact information provided on our website.
          </p>
        </section>

        <section className="border-t pt-6 mt-8">
          <p className="text-sm text-gray-500">
            Last updated: February 6, 2026
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsPage;
